import { API, graphqlOperation } from "aws-amplify";
import { 
    listItemMasterSearchCustom,
    ListItemMasterSearchQuery,
    ListItemMasterSearchQueryVariables,
} from "../../../graphql";
import { ProcessedItemMaster, ItemFinancialYearSummaryInput, ItemFinancialYearSummaryItem } from "../types/graphql";

export const listItemMasterSearchQuery = async ({ 
    variable 
}: { 
    variable: ListItemMasterSearchQueryVariables 
}): Promise<ProcessedItemMaster[]> => {
    try {
        const response = await API.graphql(
            graphqlOperation(listItemMasterSearchCustom, variable)
        ) as { data: ListItemMasterSearchQuery };
        
        return response.data.listItemMasterSearch?.map(item => ({
            itemid: item?.itemid?.toString() || '',
            itemname: item?.itemname || '',
            itemcode: item?.itemcode || '',
            itemtype: item?.itemtype || '',
            measurementcd: item?.measurementcd || '',
            hsn: item?.hsnid || undefined,
            gstrate: item?.relateditemamountdetails?.[0]?.gstrate || undefined,
            taxability: item?.taxabilitycd || undefined,
            is_active: item?.is_active || undefined,
            companyid: item?.companyid || undefined,
        })) || [];
    } catch (error) {
        throw new Error(`Failed to fetch item master search: ${error instanceof Error ? error.message : 'Unknown error'}`);
    }
}

const GET_ITEM_FINANCIAL_YEAR_SUMMARY = `
  query GetItemFinancialYearSummary($input: ItemFinancialYearSummaryInput!) {
    getItemFinancialYearSummary(input: $input) {
      itemid
      financialyearid
      openingamt
      openingqty
      purchaseamt
      purchaseqty
      closingamt
      closingqty
    }
  }
`;

export const getItemFinancialYearSummaryQuery = async ({ 
    input 
}: { 
    input: ItemFinancialYearSummaryInput 
}): Promise<ItemFinancialYearSummaryItem[]> => {
    try {
        const response = await API.graphql(
            graphqlOperation(GET_ITEM_FINANCIAL_YEAR_SUMMARY, { input })
        ) as { data: { getItemFinancialYearSummary: ItemFinancialYearSummaryItem[] } };
        
        return response.data.getItemFinancialYearSummary || [];
    } catch (error) {
        throw new Error(`Failed to fetch financial year summary: ${error instanceof Error ? error.message : 'Unknown error'}`);
    }
}
